import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RackSuggestionDto } from '.';
import { FGStockData } from './all-re-packing-stock.dto';

export class RackPositionServiceResponseModel extends GlobalResponseObject {
    data?: RackSuggestionDto;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, errorCode:number, internalMessage:string, data?: RackSuggestionDto){
        super(status,errorCode,internalMessage);
        this.data = data;
    }
}